/* eslint-disable */
import requestService from '@/js/common/Domain/Service/request';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import { extendDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import CheckBoxInputCommon from '@ve/components/inputs/common/CheckBoxInputCommon.vue';
import { mountCheckboxes, validateRequiredCheckboxes } from '@/js/common/Service/checkboxValidation';
import { getTypeBanner } from '@/js/common/Domain/Service/getTypeBanner';

@viewModelDecorator({
    defaults() {
        return {
            loading: false,
            EmailWasSend: false,
            $form: null,
            agreeAdvertising: false,
        };
    },
})
@extendDecorator({
    bindings: {
        ':el': 'classes: { success: EmailWasSend, loading: loading }',
        button: 'classes: { loading: loading }',
    },
})
export default class SubscribeEmailFormView extends Backbone.Epoxy.View {
    initialize() {
        this.initDOMEvents();
        this.dataLayerAnalytics = new DataLayerAnalytics();
    }

    initDOMEvents() {
        setTimeout(() => {
            const $forms = this.$el.find('form');
            $forms.each((i, form) => {
                const $form = $(form);
                $form.validate({
                    errorElement: 'div',
                    rules: {
                        email: {
                            required: true,
                            email: true,
                            remote: '/validate/emailValidate',
                        },
                    },
                    messages: {
                        email: {
                            required: 'Обязательное поле',
                            email: 'Неправильный емейл',
                            remote: 'Неправильный емейл',
                        },
                    },
                });
                $form.on('click', 'button', async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if ($form.valid() && !this.viewModel.get('loading')) {
                        if (!validateRequiredCheckboxes(this.viewModel, ['agreeAdvertising'], this.$el[0])) {
                            return;
                        }
                        this.viewModel.set('emailError', false);
                        await this.formSubmit($form.find('input').val());
                    }
                });
                this.viewModel.set('$form', $form);
            });
            this.$el.find('[data-subscribe-id]').each((i, el) => {
                const uniqId = $(el).attr('data-subscribe-id');
                $(el).attr('id', uniqId);
                mountCheckboxes([
                    {
                        id: uniqId,
                        modelKey: 'agreeAdvertising',
                        labelVNode: (h) => h('span', [
                            'Я даю ',
                            h('a', {
                                attrs: {
                                    href: '/consent-to-advertising',
                                    target: '_blank',
                                    class: 'link',
                                },
                            }, 'согласие на получение рекламных сообщений'),
                        ]),
                        disabled: false,
                        labelClass: 'subscribe-block-checkbox-label',
                    },
                ], this.viewModel, CheckBoxInputCommon);
            });
        }, 100);
    }

    async formSubmit(email) {
        this.viewModel.set('loading', true);
        const mindBoxUuid = await mindBoxService.getUuidMindbox();
        const context = getTypeBanner('sideBanner');
        requestService({
            type: 'POST',
            url: window.appConfig.apiGatewayUrl + '/frontend/subscriptions',
            contentType: 'application/json',
            data: JSON.stringify({
                email,
                pointOfContact: context,
                deviceUUID: mindBoxUuid,
            }),
        }).done((data) => {
            this.viewModel.set('loading', false);
            if (data && data.success) {
                this.viewModel.set('EmailWasSend', true);
                this.dataLayerAnalytics.subscribeEmail();
            } else {
                const $form = this.viewModel.get('$form');
                const $validator = $form?.validate();
                $validator?.showErrors({
                    email: 'Произошла ошибка. Попробуйте использовать другой адрес электронной почты.',
                });
            }
        }).fail(() => {
            this.viewModel.set('loading', false);
        });
    }
}
